import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { supabase } from '@/lib/supabase/client';

export function AuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const token_hash = searchParams.get('token_hash')
    const type = searchParams.get('type')
    const next = searchParams.get('next') ?? '/'

    if (token_hash && type) {
      supabase.auth.verifyOtp({
        type: type as any,
        token_hash,
      }).then(({ error }) => {
        if (!error) {
          navigate(next)
        } else {
          navigate(`/auth/error?error=${error.message}`)
        }
      })
    } else {
      navigate('/auth/error?error=No token hash or type')
    }
  }, [searchParams, navigate])

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-4">Vérification en cours...</h2>
        <p className="text-muted-foreground">Veuillez patienter pendant que nous vérifions votre email.</p>
      </div>
    </div>
  )
} 